export enum SistemasInformesEnum {
    MEDIDAS = 'Medidas',
    PREVISIONES = 'Previsiones',
    CONCILIACION = 'Conciliacion',
    DATOS_MAESTROS = 'Datos Maestros'
}
